import './Badge.sass';

import React, { FC, useMemo } from 'react';
import { BadgeProps } from './Badge.interface';

import { formatBigNumber } from '$utils';

export const Badge: FC<BadgeProps> = ({ count }) => {
  const prepared = useMemo(() => {
    const result = count > 100_000 ? formatBigNumber(count, 0) : formatBigNumber(count);

    return result;
  }, [count]);

  return <div className="Badge">{prepared}</div>;
};
